/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// react-router-dom components
import {Link} from "react-router-dom";

// @mui material components
import Checkbox from "@mui/material/Checkbox";

// Images
import bgImage from "../splash2.jpg";
import React, {useEffect, useState} from "react";
import SplashScreen from "../Layout/SplashScreen";
import {Alert, Box, Button, FormControlLabel, Paper, TextField, Typography} from "@mui/material";

export default function RegisterPage() {
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [check, setCheck] = useState(false);
  const [flashMessage, setFlashMessage] = useState("");
  const [flash, setFlash] = useState("");

  useEffect(() => {
    if (flashMessage !== '') {
      if(flashMessage === 'success') {
        setFlash(<Alert severity="success">Utworzono konto w systemie. Sprawdź swój email by dokończyć jego aktywację.</Alert>);
      } else if (flashMessage === 'warning') {
        setFlash(<Alert severity={'warning'}>Podane konto już istnieje. <br />Jeśli nie pamiętasz hasła <Link to={'/reset'}>zresetuj je</Link>.</Alert>);
      } else if (flashMessage === 'quota') {
        setFlash(<Alert severity={'warning'}>Przekroczono limit wysłanych maili aktywacyjnych. Sprawdź swoją skrzynkę pocztową.</Alert>);
      } else {
        setFlash(<Alert severity={'error'}>Rejerstracja tymczasowo niemożliwa.</Alert>);
      }
    } else {
      setFlash('');
    }
  }, [flashMessage]);
  const registerUser = (e) => {
    e.preventDefault();
    const sentData = {name: name, surname: surname, username: username, password: password};
    if (password !== passwordAgain) {
      setFlash(<Alert severity={'warning'}>Podane hasła się nie zgadzają.</Alert>);
      return null;
    }
    if (!check) {
      setFlash(<Alert severity={'warning'}>Musisz zaakceptować politykę prywatności i regulamin.</Alert>);
      return null;
    }
    fetch("/api/user/register", {
      cache: "no-cache",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sentData),
    })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          response.json().then(function (data) {
            setFlashMessage(data);
          });
        })
        .catch((error) => {
          console.log(error.message);
        });
  };

  const privacy = (<>
      <Typography
          variant="button"
          fontWeight="regular"
          color="text"
          sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
      >
        &nbsp;&nbsp;Zapoznałem się i akceptuję&nbsp;
      </Typography>
  <Typography
      component="a"
      href="https://wakacyjnezajecia.pl/polityka-prywatnosci"
      target={'_blank'}
      variant="button"
      fontWeight="bold"
      color="info"
      textGradient
  >
    Politykę prywatności
  </Typography>
  <Typography
      variant="button"
      fontWeight="regular"
      color="text"
      sx={{ cursor: "pointer", userSelect: "none"}}
  >
    &nbsp;i&nbsp;
  </Typography>
  <Typography
      component="a"
      href="https://wakacyjnezajecia.pl/regulamin"
      target={'_blank'}
      variant="button"
      fontWeight="bold"
      color="info"
      textGradient
  >
    Regulamin
  </Typography>
      </>
  );
  return (
      <SplashScreen background={bgImage} title={'Wakacyjne Zajęcia'}>
          <Paper elevation={24} sx={{width: '500px', maxWidth: '80vw', overflow: 'visible', overflowWrap: 'break-word', backgroundClip: 'border-box', paddingTop: '1px'}}>
              <Box
                  mx={2}
                  mt={-3}
                  p={2}
                  mb={1}
                  textAlign="center"
                  sx={{background: 'linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))',
                      boxShadow: 'rgba(0, 0, 0, 0.14) 0rem 0.25rem 1.25rem 0rem, rgba(64, 64, 64, 0.4) 0rem 0.4375rem 0.625rem -0.3125rem',
                      margin: '-24px 16px 8px',
                      padding: '16px',
                      borderRadius: '0.375rem',
                      opacity: 1}}
              >
          <Typography variant="h5" fontWeight="light" color="white">
            Załóż konto opiekuna
          </Typography>
        </Box>
        {flash}
        <Box pt={4} pb={3} px={3}>
          <Box component="form" role="form" onSubmit={registerUser}>
           <Box mb={2}>
            <TextField required autoFocus label="Imię" variant="outlined" fullWidth autoComplete={'name'}
                       value={name} onChange={(e) => setName(e.target.value)}/>
           </Box>
           <Box mb={2}>
            <TextField required label="Nazwisko" variant="outlined" fullWidth autoComplete={'surname'}
                       value={surname} onChange={(e) => setSurname(e.target.value)}/>
           </Box>
            <Box mb={2}>
              <TextField type="email" required label="Email" variant="outlined" fullWidth autoComplete={'email'}
                       value={username} onChange={(e) => setUsername(e.target.value)}/>
            </Box>
            <Box mb={2}>
              <TextField type="password" required label="Hasło" variant="outlined" fullWidth autoComplete={'new-password'}
                       value={password} onChange={(e) => setPassword(e.target.value)}/>
            </Box>
            <Box mb={2}>
              <TextField type="password" required label="Powtórz Hasło" variant="outlined" fullWidth autoComplete={'off'}
                       value={passwordAgain} onChange={(e) => setPasswordAgain(e.target.value)}/>
            </Box>
            <Box display="flex" alignItems="center" ml={0}>
              <FormControlLabel control={<Checkbox required checked={check}
                                                   onChange={(e) => setCheck(e.target.checked)}
              />} label={privacy} value={check} />
            </Box>
            <Box mt={4} mb={1}>
              <Button variant="contained" color="primary" fullWidth type={'submit'}>
                Załóż konto
              </Button>
            </Box>
            <Box mt={3} mb={1} textAlign="center">
              <Typography variant="button" color="text">
                Masz już konto?{" "}
                <Typography
                  component={Link}
                  to="/login"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Zaloguj się
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
          </Paper>
    </SplashScreen>
  );
}
